import { Children, isValidElement, ReactNode } from "react";
import { EmptyArray } from "../../../../../utilities/EmptyArray";
import { Action, ActionProps } from "../../Action";

/**
 * Gets the columns from the specified children.
 * @param children The children to get the columns from.
 * @returns The array of columns.
 */
export function getActions(children: ReactNode | undefined): ReadonlyArray<ActionProps> {
  return (
    Children.map(children, (child) => {
      if (!isValidElement(child)) return null;
      if (child.type !== Action) {
        console.log("Actions ignoring unsupported child component.");
        return null;
      }
      return child.props;
    })?.filter((tab) => !!tab) ?? EmptyArray
  );
}
